/**
 * On mobile, scroll a just-focused input clear of the sticky header + keyboard
 * so the field the user is typing in stays visible.
 * Attach to onFocus of a field (or a wrapping element).
 */
export function scrollFocusedFieldIntoView(e) {
  if (window.innerWidth >= 768) return;
  const el = e.target;
  setTimeout(() => {
    const rect = el.getBoundingClientRect();
    const headerOffset = 180;
    if (rect.top < headerOffset) {
      window.scrollBy({ top: rect.top - headerOffset, behavior: 'smooth' });
    }
  }, 300);
}